module.exports = __webpack_public_path__ + "static/media/chair-cover.eebf027d.svg";